import { useState } from "react";
import { format } from "date-fns";
import { vi } from "date-fns/locale";
import { Calendar } from "@/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/ui/popover";
import { Button } from "@/ui/button";
import { useIsMobile } from "@/hooks/useIsMobile";

export type DateRange = { from?: Date; to?: Date };

type Props = { value: DateRange; onChange: (r: DateRange) => void };

export function DateRangePicker({ value, onChange }: Props) {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const label =
    value.from && value.to
      ? `${format(value.from, "dd/MM/yyyy", { locale: vi })} → ${format(value.to, "dd/MM/yyyy", { locale: vi })}`
      : "Chọn khoảng ngày";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full md:w-auto">{label}</Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="range"
          locale={vi}
          numberOfMonths={isMobile ? 1 : 2}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          selected={value as any}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onSelect={(r: any) => onChange(r ?? {})}
        />
      </PopoverContent>
    </Popover>
  );
}
